




import { Component, Prop, Vue } from 'vue-property-decorator';
import MobileWalletButton from './MobileWalletButton.vue';
import { CoinflowPurchaseProps } from '../lib/common';

@Component({
  components: {
    MobileWalletButton,
  },
})
export default class CoinflowGooglePayButton extends Vue {
  @Prop({ type: Object, required: true }) args!: CoinflowPurchaseProps & {
    color: 'white' | 'black';
  };
}
